import { useQueryClient } from '@tanstack/react-query';
import type { Message } from 'ably';
import { useEffect } from 'react';

import { queries } from '../api/queryKeys/queries';

import { useAbly } from './useAbly';

export const useVesselProductUpdates = (
    vesselId?: string,
    customerId?: string,
    onUpdate?: (productCount: number) => void
) => {
    const queryClient = useQueryClient();
    const { subscribe, unsubscribe } = useAbly();

    useEffect(() => {
        if (!customerId || !vesselId) {
            return;
        }

        const channel = `customers:${customerId}:vessels:${vesselId}:products`;
        const handler = async (message: Message) => {
            const productCountString = message.name?.split(':')[1];
            const productCount = productCountString ? parseInt(productCountString, 10) : -1;

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
                }),
                queryClient.invalidateQueries({
                    queryKey: queries.vessels.detail(vesselId)._ctx.unmatchedProducts.queryKey,
                }),
            ]);

            onUpdate?.(productCount);
        };

        subscribe(channel, handler);
        return () => unsubscribe(channel);
    }, [customerId, vesselId, onUpdate, queryClient, subscribe, unsubscribe]);
};
